import { render } from "./UserSubmissions.vue?vue&type=template&id=7115dda9"
import script from "./UserSubmissions.vue?vue&type=script&lang=js"
export * from "./UserSubmissions.vue?vue&type=script&lang=js"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__